import { intersectionObserverCompatibility } from './lazy-loader';

const initializeWistiaScript = (wistiaElements) => {
  if (!wistiaElements) return;
  const wistiaIds = {};
  const wistiaEmbeds = $('.wistia_embed').length;
  const wistiaChannels = $('.wistia_channel').length;
  let hasOffsetVideo = false;
  const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) || 60;

  const wistiaEmbedOptions = {
    playerColor: '101828',
    qualityControl: true,
    preload: false
  };
  const wistiaChannelOptions = {
    color: '101828'
  };

  const appendWistiaScript = (src) => {
    if (!src) return;
    const scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.async = true;
    scriptTag.src = src;
    document.head.append(scriptTag);
  };

  const loadWistiaScript = () => {
    if (wistiaEmbeds) appendWistiaScript('https://fast.wistia.com/assets/external/E-v1.js');
    if (wistiaChannels) appendWistiaScript('https://fast.wistia.net/assets/external/channel.js');
  };

  const lazyLoadWistiaScript = () => {
    const options = {
      root: null,
      threshold: 0.1
    };

    const callback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadWistiaScript();
          actOnElements('unobserve');
        }
      });
    };

    const actOnElements = (type) => {
      switch (type) {
        case 'observe': {
          wistiaElements.each((index, element) => observer.observe(element));
          break;
        }
        case 'unobserve': {
          wistiaElements.each((index, element) => observer.unobserve(element));
          break;
        }
      }
    };

    const observer = new window.IntersectionObserver(callback, options);
    actOnElements('observe');
  };

  // Collect all wistia ids and detect offsetVideo
  wistiaElements.each(function () {
    if (!hasOffsetVideo && this.getBoundingClientRect().bottom < viewportHeight) hasOffsetVideo = true;
    this.classList.forEach((i) => {
      if (i.substring(0, 13) === 'wistia_async_') {
        wistiaIds[i.substring(13)] = true;
      }
    });
  });

  // Embed and Initialize things that require before script load
  if (wistiaEmbeds) {
    window._wq = window._wq || [];
    window._wq.push({ id: '_all',
      options: wistiaEmbedOptions
    });
    window.wistiaInitQueue = window.wistiaInitQueue || [];
    window.wistiaInitQueue.push(function (W) {
      W.embeds.dontWatch();
    });
  }
  if (wistiaChannels) {
    window._wcq = window._wcq || [];
    window._wcq.push({ id: '_all',
      options: wistiaChannelOptions
    });
  }

  // Load meta script for eachIds
  for (const wistiaId in wistiaIds) {
    appendWistiaScript(`https://fast.wistia.com/embed/medias/${wistiaId}.jsonp`);
  }

  // load script for wistia library
  if (!hasOffsetVideo && intersectionObserverCompatibility) lazyLoadWistiaScript();
  else loadWistiaScript();
};

var videoWidget = function ($ = jQuery) {
  var scrollPosition;
  // Close Modal
  function closePopup () {
    if ($('.video-popup-modal').hasClass('video-popup-active')) {
      $('.video-popup-modal').removeClass('video-popup-active');
    }
    $('body').removeClass('overflow-hidden');
    $('.video-popup-modal').fadeOut(300);
  }

  function onKeyPressEvent (event) {
    const code = event.which || event.keyCode || 0;
    if (code === 13) $(this).trigger('click');
  }

  $('.video-popup-initial-state').on('keypress', onKeyPressEvent);
  // Trigger Modal
  $('.video-popup-initial-state').on('click', function () {
    var videoID = $(this).attr('data-video-popup-target');
    if ($(this).attr('data-target') && $(this).attr('data-target').length > 0) {
      const $this = $(this);
      // This means its a gated video. Now we need to check for local storage value
      const localStorageKey = $this.attr('data-local-storage-key');
      const modalFormTarget = $this.attr('data-target');
      // Booleans are not 100% compatible with local storage.
      if (localStorage.getItem(localStorageKey) === 'true') {
        // Gated Form was already filled. Dont show it again
        $this.removeAttr('data-target').removeAttr('data-toggle');
        // Call the function recursively
        $this.trigger('click');
      } else {
        window.wistiaVideoID = videoID;
        $(`${modalFormTarget}.modal`).modal('show');
        return;
      }
    }
    scrollPosition = $(window).scrollTop();
    var popupElement = $('#video-popup-' + videoID);
    popupElement.addClass('video-popup-active');
    $('body').addClass('overflow-hidden');
    popupElement.fadeIn(300);
  });

  // Initialize Wistia Videos, if available
  if (jQuery('.video-popup-initial-state').length > 0) {
    window._wq = window._wq || [];
    jQuery('.video-popup-initial-state').each(function (index, element) {
      const elementID = jQuery(element).attr('data-video-popup-target');
      const wistiaObject = {};
      wistiaObject[elementID] = function (video) {
        var thisElementID = elementID;

        // When the user clicks anywhere outside of the modal, close it
        $('#video-popup-' + thisElementID).on('click', function (event) {
          var modal = document.getElementsByClassName('video-popup-active')[0];
          if (event.target === modal) {
            closePopup();
            video.pause();
            video.replaceWith(thisElementID);
          }
        });

        $('#video-popup-trigger-' + thisElementID).click(function () {
          video.play();
        });

        $('#video-popup-close-' + thisElementID).on('keypress', onKeyPressEvent);

        $('#video-popup-close-' + thisElementID).on('click', function () {
          video.pause();
          video.replaceWith(thisElementID);
          window.scrollTo(0, scrollPosition);
          closePopup();
        });
      };
      window._wq.push(wistiaObject);
    });
  }

  // Initialize Normal Wistia Videos, if available
  if (jQuery('.video-default-state').length > 0) {
    window._wq = window._wq || [];
    jQuery('.video-default-state').each(function (index, element) {
      const elementID = jQuery(element).attr('data-video-target');
      const wistiaObject = {};
      wistiaObject[elementID] = function (video) {
        var thisElementID = elementID;
        jQuery('.play-button', '#video-' + thisElementID).on('click', function () {
          video.play();
        });
        video.bind('play', function () {
          jQuery('.play-button', '#video-' + thisElementID).hide();
          var offset;
          if (jQuery(window).width() < 960) {
            offset = 60;
          } else {
            offset = 70;
          }
          jQuery('html, body').animate({
            scrollTop: (jQuery('#video-' + thisElementID).offset() || { top: NaN }).top - offset
          }, 500);
        });
        video.bind('pause', function () {
          jQuery('.play-button', '#video-' + thisElementID).show();
        });
        video.bind('end', function () {
          if (!jQuery('.play-button').hasClass('hide-play-end')) {
            jQuery('.play-button', '#video-' + thisElementID).show();
          } else {
            jQuery('.play-button', '#video-' + thisElementID).hide();
          }
        });
      };
      window._wq.push(wistiaObject);
    });
  }
  // commenting this code as this was a previous requirements which was not used
  // Below was the requirements
  // Video background to be used in fw-section-banner-cta
  // custom play button was required for custom functionality
  // const $videoBanner = jQuery('.banner-full-width-video');

  // if ($videoBanner.length > 0) {
  //   window._wq = window._wq || [];
  //   $videoBanner.each(function (index, element) {
  //     const _this = jQuery(element);
  //     const elementID = jQuery(element).attr('data-video-id');
  //     const wistiaObject = {};
  //     const $bannerOverlay = _this.find('.banner-overlay');
  //     const $bannerContent = _this.closest('.video-banner').find('.banner-content');
  //     wistiaObject[elementID] = function (video) {
  //       _this.find('.play-button').on('click', function () {
  //         $bannerOverlay.hide();
  //         video.play();
  //       });
  //       video.bind('play', function () {
  //         _this.find('.play-button').hide();
  //         $bannerContent.fadeOut();
  //       });
  //       video.bind('pause', function () {
  //         $bannerContent.fadeIn();
  //         $bannerOverlay.show();
  //         _this.find('.play-button').show();
  //       });
  //       video.bind('end', function () {
  //         $bannerContent.fadeIn();
  //       });
  //     };
  //     window._wq.push(wistiaObject);
  //   });
  // }

  // Add the wistia script here to ensure that the _wq global
  // object is populated before the wistia player loads
  const wistiaElements = $('[class*=wistia_async_]');
  if (wistiaElements.length) initializeWistiaScript(wistiaElements);
};
export { videoWidget };
